import React from 'react';
import { getFileExtention, getFileName } from '../../utils/attachments';

export default function Document({ src }) {
  return (
    <>
      <div className="flex justify-center">
        <a href={src} download={getFileName(src)} target="_blank">
          <div className="document">
            <div className="triangle"></div>
            <div className="triangle-corner"></div>
            <span className="text-center flex items-center justify-center absolute left-0 right-0 top-0 bottom-0 m-auto">
              {getFileExtention(src)?.toUpperCase() || 'File'}
            </span>
          </div>
        </a>
      </div>
      <div className="text-xs text-gray-300 block gap-2 mt-3 px-1">
        <p className="flex justify-center w-36 break-all">{getFileName(src)}</p>
      </div>
    </>
  );
}
